import { render, staticRenderFns } from "./DxCardsV2.vue?vue&type=template&id=e5493250&scoped=true&"
import script from "./DxCardsV2.vue?vue&type=script&lang=js&"
export * from "./DxCardsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5493250",
  null
  
)

export default component.exports